/**
 * Athos configuration utilities
 * Provides site ID, origin and domain configuration for the Athos v1 discovery API.
 */

import { globalState } from '@/components/helpers/utils'

export function getAthosSiteID(category = 'products'): string {
  return globalState.siteIds[category]
}

/**
 * Standard discovery API origin (search, category, autocomplete, suggest, trending, meta).
 * @param {string} siteID
 * @returns {string}
 */
export function getApiOrigin(siteID: string): string {
  return `https://${siteID}.a.athoscommerce.net/v1`
}

/**
 * Personalization (P13N) origin — Athos serves recommendations from a dedicated
 * cluster, distinct from the standard discovery origin.
 * @param {string} siteID
 * @returns {string}
 */
export function getPersonalizationOrigin(siteID: string): string {
  return `https://${siteID}.a.p13n.athoscommerce.net/v1`
}

/**
 * Beacon 2.0 analytics origin.
 * @returns {string}
 */
export function getBeaconOrigin(): string {
  return 'https://analytics.athoscommerce.net/beacon/v2'
}

/**
 * The `domain` param is contextual only — Athos selects the data feed via the
 * per-category `siteId` (the request subdomain), so `domain` should carry the
 * actual current page URL for analytics/merchandising, not a feed URL.
 * @returns {string}
 */
export function getAthosDomain(): string {
  return window.location.href
}

/**
 * Whether the merchant has the in-stock-only background constraint enabled.
 * Deliberately `=== true`, not `!== false`: `config/*.json` is excluded from
 * `--build` deploys, so a code-only deploy renders this setting as `null` —
 * the constraint must stay dormant until the `--content` deploy lands the
 * schema and the merchant toggle.
 * @returns {boolean}
 */
export function isAthosInstockOnly(): boolean {
  return globalState.athosInstockOnly === true
}
